import React from 'react'
import {Layout, Col, Row, Icon, Badge} from 'antd'
import {Link} from 'react-router-dom'

import {invitesService} from 'services'
import useUserContext from 'components/User/useUserContext'
import requestHandler from 'utils/requestHandler'
import Routes from './Routes'
import MainMenu from './MainMenu'
import MainBreadcrumbs from './MainBreadcrumbs'
import MainAvatar from './MainAvatar'

const MainLayout = ({history}) => {
  const [collapsed, setCollapsed] = React.useState(window.innerWidth < 767)
  const {user, setUser} = useUserContext()

  React.useEffect(() => {
    setUser(u => ({...u, notificationsCount: undefined}))
    requestHandler(() => invitesService.getInvites(user.accountantProfile.uuid, user.accessToken, 0), 'json')
      .then(response => {
        if (response?.data?.items) setUser(u => ({...u, notificationsCount: response.data.total}))
        else setUser(u => ({...u, notificationsCount: null}))
      })
  }, [user.accountantProfile.uuid, user.accessToken, setUser])

  return (
    <Layout style={{minHeight: '100vh'}}>
      <Layout.Sider collapsible collapsed={collapsed} onCollapse={() => setCollapsed(!collapsed)} theme='light'>
        <Link to='/home'><div className="logo"><div/></div></Link>
        <MainMenu pathname={history.location.pathname}/>
      </Layout.Sider>

      <Layout style={{marginLeft: collapsed ? 80 : 200, transition: 'margin-left .2s'}}>
        <Layout.Header style={{background: 'transparent', padding: '0 24px'}}>
          <Row type="flex" justify="center" align="top">
            <Col xs={{span: 0}} sm={{span: 0}} md={{span: 12}}>
              <div style={{padding: '6px 0'}}><MainBreadcrumbs/></div>
            </Col>
            <Col xs={{span: 24}} sm={{span: 24}} md={{span: 12}}>
              <div className='mainAvatar'>
                <div className='notifications'>
                  <Link to='/home/received-invites'>
                    {user.notificationsCount === undefined ? (
                      <Icon type='loading'/>
                    ) : (
                      <Badge count={user.notificationsCount} title='Unprocessed incoming invites'>
                        <Icon type='bell' theme='twoTone' twoToneColor={user.notificationsCount ? 'red' : '#bbb'}/>
                      </Badge>
                    )}
                  </Link>
                </div>
                <MainAvatar user={user}/>
              </div>
            </Col>
          </Row>
        </Layout.Header>
        <Layout.Content style={{margin: '0 16px'}}>
          <div style={{padding: 24, background: '#fff'}}>
            <Routes/>
          </div>
        </Layout.Content>
        <Layout.Footer style={{textAlign: 'center'}}>Buildiro Tech UK Ltd. &copy; {(new Date()).getFullYear()}</Layout.Footer>
      </Layout>
    </Layout>
  )
}

export default MainLayout
